// @ts-ignore
import ImportCDNJs from 'import-cdn-js';
import track from '@relx/shence';
import { TGetGps } from './types';
import AMapLoader from '@amap/amap-jsapi-loader';

const memo = {
  AMap: null,
};
export const LoadAMap = () => {
  if (memo.AMap) return Promise.resolve(memo.AMap);
  return AMapLoader.load({
    key: 'f570c9699fe3b7bca14b86b582828fc1',
    version: '2.0',
    plugins: ['AMap.Geolocation'],
  }).then(amap => {
    memo.AMap = amap;
    return amap;
  });
};

const AMapLocation = () => {
  return new Promise((resolve, reject) => {
    LoadAMap().then(AMap => {
      // console.log('Amp', AMap)
      // const geolocation = new AMap.Geolocation();
      AMap.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认：true
          timeout: 10000, // 设置定位超时时间，默认：无穷大
          offset: [10, 20], // 定位按钮的停靠位置的偏移量
          zoomToAccuracy: true, //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          position: 'RB', //  定位按钮的排放位置,  RB表示右下
        });
        geolocation.getCurrentPosition(function(status: any, result: any) {
          if (status == 'complete') {
            resolve(result?.position);
          } else {
            reject(result);
          }
        });
      });
    });
  });
};

const getGps: TGetGps = () => {
  return new Promise(async (resLocation, rejLocation) => {
    try {
      // const qq = await ImportCDNJs(
      //   'https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js',
      //   'qq',
      // );
      // const geolocation = new qq.maps.Geolocation(
      //   'IFXBZ-ODRKU-2XAVU-2YL3C-PAS33-T4FLD',
      //   'find',
      // );
      const position: any = await AMapLocation();
      if (position?.type === 'ip') {
        track.biz('reject_location_permission');
      }
      if (position?.lat && position?.lng) {
        resLocation({
          lat: position.lat,
          lng: position.lng,
        });
      } else {
        track.biz('qq_location_incomplete', {
          lat: position.lat,
          lng: position.lng,
        });
        rejLocation({
          errMsg: 'qq经纬度不全',
        });
      }
    } catch (error) {
      rejLocation(error);
      track.biz('location_fail_qq', {
        reason: typeof error === 'object' ? JSON.stringify(error) : error,
      });
    }
  });
};

export default getGps;
